import * as React from "react";
import styles from "./stylesPromotionDetails.css";
import { PauseOutlined } from "@ant-design/icons";
import { AppStrings } from "../../../../../utils/constants/AppStrings";

const PromotionHeader = ({ status, title }) => (
  <header className="header">
    <h2 className="headerTitle">{title}</h2>
    <span className="statusBadge">{status}</span>
  </header>
);

const InfoRow = ({ label, value, subValue }) => (
  <div className="infoRow">
    <span className="label">{label}</span>
    <strong className="value">{value}</strong>
    {subValue && <span className="subValue">{subValue}</span>}
  </div>
);

const SplitInfoRow = ({ leftLabel, leftValue, rightLabel, rightValue }) => (
  <div className="splitRow">
    <div className="splitColumn">
      <span className="label">{leftLabel}</span>
      <strong className="value">{leftValue}</strong>
    </div>
    <div className="splitColumn">
      <span className="label">{rightLabel}</span>
      <strong className="value">{rightValue}</strong>
    </div>
  </div>
);

const ActionButtons = () => (
  <section className="actionSection">
    <div className="buttonGroup">
      <button className="primaryButton">
      <PauseOutlined />
        <span>{AppStrings.SUSPEND}</span>
      </button>
      <button className="secondaryButton">{AppStrings.EDIT}</button>
    </div>
    <button className="finishButton">{AppStrings.FINISH_PROMO}</button>
  </section>
);

function PromotionDetails() {
  return (
    <article className="promotionCard">
      <PromotionHeader status={AppStrings.PAM_PROMOTIONS_STATUS_ACTIVE} title={AppStrings.DETAILS} />

      <InfoRow label={AppStrings.PROMOTION_TYPE} value={AppStrings.PROFIT_BOOST} />

      <SplitInfoRow
        leftLabel={AppStrings.START_DATE}
        leftValue="Nov 28, 2024"
        rightLabel={AppStrings.END_DATE}
        rightValue="–"
      />

      <InfoRow label={AppStrings.EXPIRATION_PERIOD} value="7 days" />

      <SplitInfoRow
        leftLabel={AppStrings.ELIGIBLE_BET_TYPE}
        leftValue="Parlay (SGP)"
        rightLabel={AppStrings.PREMATCH_LIVE}
        rightValue="All"
      />

      <SplitInfoRow
        leftLabel={AppStrings.MIN_LEGS}
        leftValue="3"
        rightLabel={AppStrings.MAX_LEGS}
        rightValue="8"
      />

      <SplitInfoRow
        leftLabel={AppStrings.ODDS_BOOST_PERCENTAGE}
        leftValue="20%"
        rightLabel={AppStrings.PROGRESSIVE_BOOST}
        rightValue="+5% each extra leg"
      />

      <SplitInfoRow
        leftLabel={AppStrings.SPORTS}
        leftValue="All"
        rightLabel={AppStrings.LEAGUES}
        rightValue="All"
      />

      <SplitInfoRow
        leftLabel={AppStrings.TEAMS}
        leftValue="All"
        rightLabel={AppStrings.EVENTS}
        rightValue="All"
      />

      <SplitInfoRow
        leftLabel={AppStrings.MIN_ODDS}
        leftValue="-"
        rightLabel={AppStrings.MAX_ODDS}
        rightValue="+800"
      />

      <ActionButtons />
    </article>
  );
}

export default PromotionDetails;
